import { Heading, Paragraph } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';

import { PageWrapper } from '../solceller';

import { OppvarmingForm } from './form';
import { fromUserInputToOppvarmingFormData } from './form/dataMapper';

export const Oppvarming = () => {
  const { t } = useTranslation();
  const store = useStore();
  const userInput = store.getState().register.userInput;

  const defaultValues = fromUserInputToOppvarmingFormData(userInput);

  return (
    <PageWrapper>
      <Heading level={1} data-size="lg">
        {t('form.oppvarming.pageTitle')}
      </Heading>
      <Paragraph className="text-preline">{t('form.oppvarming.info')}</Paragraph>
      <OppvarmingForm defaultValues={defaultValues} />
    </PageWrapper>
  );
};
